{
  "footer": {
    "copyright": "© 2026 Еф Ес Академи ООД ⋅ <PrivacyPolicy>Политика за лични данни</PrivacyPolicy>"
  },
  "nav": {
    "about-us": "За нас",
    "contacts": "Контакти",
    "home": "Начало",
    "services": "Услуги",
    "solutions": "Решения"
  },
  "privacy-policy-url": "/legal/privacy-policy/latest",
  "sec1": {
    "button-employee-login": "Вход за служители",
    "button-manager-login": "Вход за управители",
    "open-in": "Отворете в",
    "title1": "Дигиталната трансформация на хранителната безопасност",
    "title2": "Без хартия. Всичко в телефона."
  },
  "sec2": {
    "left": {
      "item1": "Дигитална платформа за входящ контрол и контролни карти",
      "item2": "Онлайн обучения на служителите по безопасност на храните",
      "item3": "Електронен архив на документи",
      "item4": "Консултации при отваряне на обект",
      "item5": "HACCP документация",
      "item6": "Вътрешни проверки и одити",
      "title": "Нашите решения"
    },
    "right": {
      "item1": "Без хартия – всичко в телефона",
      "item2": "Видео уроци и тестове, организирани по позиции и нива – лесно и ефективно",
      "item3": "Автоматични напомняния за изтичащи срокове",
      "item4": "Спестяване на време и ресурси",
      "item5": "Лесна интеграция в ежедневната работа",
      "item6": "Създадена от консултанти с дългогодишен опит по безопасност на храните",
      "title": "Предимства"
    }
  },
  "sec3": {
    "service1": {
      "item1": "Удобен интерфейс, който драстично намалява времето за попълване",
      "item10": "Административен панел за централизиран контрол на попълването",
      "item2": "AI – Monitoring на контролни карти",
      "item3": "Засичане на грешки, липсващи стойности и нереалистични данни",
      "item4": "Интелигентен анализ на данните за повишаване на безопасността",
      "item5": "Отчети и препоръки за подобрение",
      "item6": "Повишена прозрачност и проследимост",
      "item7": "Задаване на крайни срокове за попълване",
      "item8": "Бърз достъп до попълнени контролни карти при проверка",
      "item9": "Надежден архив на попълнените контролни карти",
      "subtitle": "Улеснено попълване на контролни карти директно от смартфон",
      "title": "Електронни контролни карти"
    },
    "title": "Услуги"
  },
  "sec5": {
    "consulting": {
      "group1": {
        "item1": "Обективна оценка и реална представа за състоянието на обекта",
        "item2": "Проверки на място по утвърдени чеклисти",
        "item3": "Снимков материал и конкретни препоръки",
        "item4": "Съпоставка между реалното състояние и записите в системата",
        "item5": "Доклад с анализ и препоръки към собственика / управителя",
        "title": "Вътрешни проверки"
      },
      "group2": {
        "item1": "Професионална помощ от първия ден",
        "item2": "Подготовка за първоначална регистрация",
        "item3": "Проверка на технологични проекти и поточност",
        "title": "Консултации при отваряне на хранителен обект"
      },
      "group3": {
        "item1": "Пълна система от документи, готова за практическо прилагане",
        "item2": "Разработване и внедряване на HACCP план",
        "item3": "Актуализация на документация при промени",
        "title": "Документация и HACCP"
      },
      "link": "Научете повече на <Link>fsconsulting.bg</Link>",
      "subtitle": "За безпроблемна работа на хранителен обект"
    },
    "organizer": {
      "item1": "Контролиран достъп на служителите до документите",
      "item2": "Възможност за добавяне на напомняния за обновяване на изтичащи документи със срок",
      "item3": "Надеждно съхраняване на документите",
      "subtitle": "Дигитален архив на всички важни за организацията документи по институции"
    },
    "service2": {
      "item1": "Директно добавяне на документите чрез камерата на телефона в защитено облачно пространство, без да натоварват паметта му",
      "item2": "Възможност за работа на няколко служителя едновременно – служител, деловодител, счетоводител, контролен орган",
      "item3": "Преглед, споделяне или разпечатване на вече създадените документи",
      "item4": "Търсене и филтриране на документите по зададени критерии",
      "subtitle": "Спестява време и усилия за ръчна обработка на придружаващите документи",
      "title": "Входящ контрол"
    },
    "subtitle1": "Консултантски услуги",
    "subtitle4": "Органайзер",
    "training": {
      "item1": "Систематизирано и актуално съдържание – над 130 страници материал в 10 видео урока по около 20 минути",
      "item2": "Отговарящо на световни високи изисквания за качество и ефективност на преподаване",
      "item3": "Тестова форма на проверка на знанията",
      "item4": "Лесно организиране на обученията спрямо нуждите и заеманите позиции на служителите",
      "item5": "Възможност за планиране на опреснителни обучения през календара на платформата",
      "item7": "Курсът е сертифициран от <Cpd>The CPD Certification Service</Cpd> – водеща международна организация за акредитация на обучения за продължаващо професионално развитие (CPD).",
      "subtitle": "Заменя лекционната форма с модерно и привличащо вниманието мултимедийно обучение",
      "subtitle1": "Обучение по безопасност на храните"
    }
  },
  "sec6": {
    "p1": "Food Safety Academy е създадена с една ясна мисия – да направи безопасността на храните реална практика, а не просто документ. Ние вярваме, че качествената и безопасна храна е резултат от знания, прилагани ежедневно – не само по време на проверки, а във всеки работен ден, от всеки член на екипа.",
    "p2": "Нашите продукти и обучения са разработени така, че да обединят теорията с реалния опит от професионалната кухня и контролната практика. Те дават на хората увереност да работят правилно, а на бизнеса – спокойствие и проследимост.",
    "p3": "Знаем, че в среда, където често се правят компромиси, истинският професионализъм започва с лична отговорност. Затова нашият екип създава решения, които подпомагат фирмите да изграждат култура на безопасност – базирана на знание, прозрачност и реални действия.",
    "p4": "Food Safety Academy – защото има значение.",
    "title": "За нас"
  },
  "sec7": {
    "demo": "За 10-минутно демо",
    "email": "Email: <Email/>",
    "phone": "Телефон: <Phone/>",
    "title": "Свържете се с нас"
  },
  "sec8": {
    "subtitle": "Станете част от екипа",
    "text": "Ако искате да участвате в разпространението на тази платформа, свържете се с нас за повече информация на <Email/> със заглавие <strong>Дистрибуция и разпространение</strong>",
    "title": "Кариери"
  },
  "subtitle": "Дигитална платформа за безопасност на храните",
  "title": "Food Safety Academy"
}
